import {
  Box,
  Button,
  CloseButton,
  Drawer,
  DrawerContent,
  Flex,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorMode,
  useColorModeValue,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

import { Link, Route, Routes, useNavigate } from "react-router-dom";
import logo from "../../assets/img/if.png";

//Context
import { UserAuth } from "../../auth/AuthContext";

//Icoons
import { BsPersonBadgeFill } from "react-icons/bs";
import { FaCar } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";
import { IoBusinessSharp, IoLogOut, IoMoon, IoSunny } from "react-icons/io5";

//Routes
import { TriangleDownIcon } from "@chakra-ui/icons";
import { AdminRoute } from "../../Rotas/PrivateRoute";
import { CarroInfo, FiliaisGrids } from "../../components";
import FeedFilias from "../../components/FeedFilias";
import Carros from "../Category/Carros";
import Motoristas from "../Category/Motoristas";
import UserProfile from "../Category/UserProfile";
import CreateAcc from "./CreateAcc";

const LinkItems = [
  { name: "Filiais", iconSrc: <IoBusinessSharp fontSize={25} />, path: "/" },
  { name: "Carros", iconSrc: <FaCar fontSize={25} />, path: "/carros" },
  {
    name: "Motoristas",
    iconSrc: <BsPersonBadgeFill fontSize={25} />,
    path: "/motoristas",
  },
];

export default function Home({ children }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Box minH="100vh" bg={useColorModeValue("gray.50", "gray.800")}>
      <SidebarContent
        onClose={() => onClose}
        display={{ base: "none", md: "block" }}
      />

      <Drawer
        autoFocus={false}
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
        size="full"
      >
        <DrawerContent>
          <SidebarContent onClose={onClose} />
        </DrawerContent>
      </Drawer>
      {/* mobilenav */}
      <MobileNav display={{ base: "flex", md: "none" }} onOpen={onOpen} />

      <Box ml={{ base: 0, md: 60 }} p="4">
        <Routes>
          <Route path="/" element={<FiliaisGrids />} />
          <Route path="/filial/:filialId" element={<FeedFilias />} />
          <Route
            path="/filial/:filialId/carro/:carroId"
            element={<CarroInfo />}
          />
          <Route path="/carros" element={<Carros />} />
          <Route path="/motoristas" element={<Motoristas />} />
          <Route
            path="/criar"
            element={
              <AdminRoute>
                <CreateAcc />
              </AdminRoute>
            }
          />
          <Route path="/user/:userId" element={<UserProfile />} />
        </Routes>
      </Box>
    </Box>
  );
}

const SidebarContent = ({ onClose, ...rest }) => {
  const toast = useToast();
  const navigate = useNavigate();
  const { user, logoutHook } = UserAuth();
  const [username, setUsername] = useState("");

  useEffect(() => {
    if (user && user.displayName) {
      setUsername(user.displayName);
    }
  }, [user]);

  const ToastDeslogado = () => {
    return toast({
      title: "Deslogado com sucesso!",
      position: "bottom",
      status: "success",
      variant: "top-accent",
      duration: 3000,
      isClosable: true,
    });
  };

  const handleLogout = async () => {
    try {
      await logoutHook();
      ToastDeslogado();
      navigate("/login", { replace: true });
    } catch (e) {
      console.log(e);
    }
  };

  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Box
      bg={useColorModeValue("gray.100", "gray.900")} //BG DA NAVBAR
      borderRight="1px"
      borderRightColor={useColorModeValue("gray.200", "gray.700")} //BORDA DA NAVBAR
      w={{ base: "full", md: 60 }} //TAMANHO DA NAVBAR
      pos="fixed"
      h="full"
      {...rest}
    >
      <Flex h="20" alignItems="center" mx="8" justifyContent="space-between">
        <Image src={logo} width={"150px"}></Image>
        <CloseButton display={{ base: "flex", md: "none" }} onClick={onClose} />
      </Flex>

      <Flex
        minWidth="max-content"
        justifyContent={"center"}
        alignItems="center"
        direction={"column"}
        mb={2}
      >
        <Menu>
          <MenuButton
            as={Button}
            colorScheme="blue"
            bgGradient="linear(to-r, blue.500, green.500)"
            width={"95%"}
          >
            {username ? username : null}
            <TriangleDownIcon />
          </MenuButton>
          <MenuList shadow={"lg"}>
            <Link to={`/user/${user.uid}`}>
              <MenuItem onClick={onClose}>Minha Conta</MenuItem>
            </Link>
            <Link to={`/criar`}>
              <MenuItem onClick={onClose}>Criar Usuário</MenuItem>
            </Link>
            <MenuItem
              flexDirection={"row"}
              alignItems="center"
              gap={4}
              onClick={() => {
                handleLogout();
                localStorage.removeItem("authToken");
              }}
            >
              Sair <IoLogOut fontSize={20} />
            </MenuItem>
          </MenuList>
        </Menu>
        {colorMode === "light" ? (
          <Button
            p="4"
            mx="4"
            onClick={toggleColorMode}
            leftIcon={<IoMoon />}
            variant="solid"
            width={"95%"}
            mt={2}
            colorScheme="blue"
            bgGradient="linear(to-r, blue.500, green.500)"
          >
            Tema Claro
          </Button>
        ) : (
          <Button
            p="4"
            mx="4"
            onClick={toggleColorMode}
            leftIcon={<IoSunny />}
            variant="solid"
            width={"95%"}
            mt={2}
            colorScheme="blue"
            bgGradient="linear(to-r, blue.500, green.500)"
          >
            Tema Escuro
          </Button>
        )}
      </Flex>

      {LinkItems.map((link) => (
        <NavItem
          fontWeight="500"
          key={link.name}
          iconSrc={link.iconSrc}
          path={link.path}
          name={link.name}
          onClick={onClose}
        >
          {link.name}
        </NavItem>
      ))}
      <Image
        p="6"
        mx="6"
        src="https://api.netlify.com/api/v1/badges/6c26f8bf-1421-4129-88c0-d6ec3c3aaac3/deploy-status"
        alt="Deploy Status"
      />
    </Box>
  );
};

const NavItem = ({ name, iconSrc, path, children, ...rest }) => {
  return (
    <Link
      to={path}
      {...rest}
      style={{ textDecoration: "none" }}
      _focus={{ boxShadow: "none" }}
    >
      <Flex
        align="center"
        p="4"
        mx="4"
        borderRadius="lg"
        role="group"
        cursor="pointer"
        _hover={{
          bgGradient: "linear(to-r, blue.500, green.500)",
          color: "white",
        }}
        {...rest}
      >
        <Flex align="center">
          {iconSrc}
          <Text fontSize="lg" ml={4}>
            {name}
          </Text>
        </Flex>
      </Flex>
    </Link>
  );
};

const MobileNav = ({ onOpen, ...rest }) => {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      wrap="wrap"
      padding="1.5rem"
      bg={useColorModeValue("gray.50", "gray.800")}
      {...rest}
    >
      <Flex align="center" mr={5}>
        <Text fontSize="xl" fontWeight="medium">
          <Image src={logo} width={"150px"}></Image>
        </Text>
      </Flex>

      <Box display={{ base: "block", md: "none" }}>
        <Flex align="center">
          <Flex onClick={toggleColorMode} mr={5} cursor={"pointer"}>
            {colorMode === "light" ? (
              <IoMoon fontSize={25} />
            ) : (
              <IoSunny fontSize={25} />
            )}
          </Flex>
          <IconButton
            aria-label="Open navigation menu"
            icon={<FiMenu />}
            size="lg"
            onClick={onOpen}
          />
        </Flex>
      </Box>
    </Flex>
  );
};
